import { authApi } from '@api';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

const useResetPassword = (options?: UseMutationOptions<unknown, unknown, { id: string; password: string }>) => {
  return useMutation({
    ...options,
    mutationFn: authApi.resetPassword,
  });
};

export default useResetPassword;
